import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ai-chatbot-generate-presentations-button',
  templateUrl: './ai-chatbot-generate-presentations-button.component.html',
  styleUrl: './ai-chatbot-generate-presentations-button.component.scss',
  standalone: false
})
export class AiGeneratePresentationsButtonComponent {
  @Input() isSearchResult: boolean;
  @Output() openAiChatbot = new EventEmitter<void>();

  onButtonClick(): void {
    this.openAiChatbot.emit();
  }
}
